import React from 'react';
import PropTypes from 'prop-types';
import { parse } from 'date-fns';
import { manualSchedulesPropTypes, manualSchedulePropTypes } from 'constants/propTypes';
import Message from 'components/Message';
import ScheduleRow from './ScheduleRow/ScheduleRowContainer';

const SchedulesGroupForDate = ({ date, schedules, registerRef }) => (
  <>
    <div className="schedules-list__date-header">
      <Message format="short-w-dow" value={parse(date, 'yyyyMMdd', new Date())} />
    </div>
    <div>
      {schedules.map(({ id, schedule, instructorName, isFuture, status, startingAt }) => (
        <ScheduleRow
          key={id}
          instanceId={id}
          instructorName={instructorName}
          schedule={schedule}
          isFuture={isFuture}
          status={status}
          registerRef={registerRef}
          startingAt={startingAt}
        />
      ))}
    </div>
  </>
);

SchedulesGroupForDate.propTypes = {
  schedules: PropTypes.oneOfType([manualSchedulePropTypes, manualSchedulesPropTypes]),
  date: PropTypes.string,
  registerRef: PropTypes.func,
};

export default SchedulesGroupForDate;
